export default {
  banner: {
    title: "多租户管理",
    subtitle:
      "Authing 多租户，能帮助企业快速构建多租户管理架构，面对企业服务、子公司管理、集成商系统整合等场景，无需从 0 构建，快速实现数据隔离和资源权限隔离的多租户开发框架。",
    img: "tenant-banner-img1.png",
    data: {
      item1: "加快产品开发上线",
      item2: "减少运营维护成本",
      item3: "保障数据隔离安全",
      item4: "提升租户扩展灵活性",
    },
  },
  scene: {
    title: "典型多租户场景全面覆盖",
    item1: {
      img: "https://files.authing.co/authing-website/tenant-enterprise.png",
      title: "我是「为企业服务的 2B 公司」",
      list1:
        "企业即租户：我的 SaaS 软件同时提供给多个企业客户使用。他们共享一套资源系统，但各自的数据与配置需保持独立。",
      list2: "多租户架构相当复杂，从零开始搭建至少需要 6 个月，自研成本高。",
    },
    item2: {
      img: "https://files.authing.co/authing-website/tenant-group.png",
      title: "我是「拥有复杂组织的大型集团」",
      list1:
        "子公司/部门即租户：作为集团的管理员，我需要根据不同子公司/部门配置不同的企业业务流程，同时确保数据和资源权限安全可控。",
      list2:
        "集团企业业务复杂，若要面向不同业务实现个性化的工作流，需构建多租户架构，同时满足数据安全要求。",
    },
    item3: {
      img: "https://files.authing.co/authing-website/tenant-user.png",
      title: "我是「面向用户的服务平台」",
      list1:
        "分销商即租户：我为终端用户提供一套数字化服务平台，同时通过分销商服务于用户；需保证每个分销商能控制不同资源的权限分配，为用户提供定制化的良好体验。",
      list2:
        "在此多租户业务场景下，需要为分销商提供灵活、自由的租户配置能力，帮助分销商更好地管理用户。",
      list3: "常见应用：开发者平台、多人共享协作类平台等。",
    },
  },
  feature: {
    item1: {
      title: "成熟的多租户架构，快速实现数据/资源/权限隔离",
      descript:
        "Authing 提供企业完备的多租户架构，可复用、可扩展，企业无需自研复杂的多租户逻辑，直接接入 Authing 即可实现各租户数据、权限、设置的独立性。",
    },
    item2: {
      title: "完备的多租户控制台，管理租户零投入",
      descript:
        "作为多个租户的管理者，企业依托 Authing 的基础身份能力，能轻松地创建/导入租户、配置租户的关联应用和身份源、定义租户间的隔离性和审计租户内的用户行为。",
    },
    item3: {
      title: "强大的 API 扩展能力，提升租户系统灵活性",
      descript:
        "Authing 提供 PaaS 化接入能力，管理员可以通过接入 Authing 的管理侧 API，在自己的系统界面管理用户池下的租户资源，执行用户管理、应用管理、租户配置等任务。",
    },
    item4: {
      title: "无代码登录配置，满足租户个性化品牌需求",
      descript:
        "Authing 提供租户自定义登录界面和登录认证方式的能力，能确保登录模块符合独立的品牌需求，也符合自身用户的登录习惯。",
    },
    item5: {
      title: "独立的业务系统，赋能下游租户数字化运营",
      descript:
        "Authing 多租户系统同时为下游租户提供了管理终端用户/成员的完整管理后台，无需额外研发，你的下游租户就能通过该后台运营管理最终用户/成员。",
    },
  },
  expend: {
    title: "依托身份中台，实现灵活可扩展的多租户能力",
    img: "https://files.authing.co/authing-website/tenant-expend.png",
  },
  customer: {
    title: "他们也使用 Authing 实现多租户能力",
    item1: {
      title1: "风变科技",
      descript1: "致力于自动化教学技术，目前 GMV 总和已达数十亿。",
      title2: "提升业务效能，专注商业发展",
      descript2:
        "Authing 的多租户功能，让每个分销商都能拥有独立的登录认证系统，能够自定义登录方式与界面，把控用户的看课权限。这不仅帮助我们更高效的管理下游分销商，也为我们带来巨大的收益。",
    },
    item2: {
      title1: "视觉动力",
      descript1: "国内工业级新能源发电领域 SaaS 集成服务开创者。",
      title2: "高效搭建租户体系，快速上线应用",
      descript2:
        "借助 Authing 的多租户功能，我们快速实现了面向企业的 SaaS 多租户模型，使我们的企业客户能够进行自我管理，大幅节省了我们构建多租户的成本，及后续维护多租户隐形的成本。",
    },
    item3: {
      title1: "Regrello",
      descript1: "硅谷创业公司，专为跨公司协作而设计的供应链工作流工具开发商",
      title2: "平滑迁移租户，加快市场拓展",
      descript2:
        "拓展大陆市场时，我们需要一个本土的服务商，提供中国客户更顺畅的登录认证体验。因此，我们选择使用 Authing，他们的产品操作便捷易上手，帮助我们平滑迁移多个租户，能很好地满足中国市场的需求。",
    },
  },
};
